import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { convertThenFormat } from "../../common-data/Converts";

const GymWiseStatsMobile = ({ allGymStatsData }) => {
  return (
    <div className="all-leads-log mt30">
      {allGymStatsData?.length > 0 &&
        allGymStatsData.map((item, index) => {
          if (item?.gym_name?.toLowerCase() === "total") return null;

          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="card-other-info">
                  <span className="value semi-bold">
                    {item?.gym_name || "NA"}
                  </span>
                  <span className="value semi-bold">
                    PT Prospects -{" "}
                    <b style={{ color: "#00B295" }}>
                      ₹{convertThenFormat(item?.total_pt_prspct_value || 0)}{" "}
                      {item?.total_pt_prspct
                        ? `(${item.total_pt_prspct})`
                        : null}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Hot PT Prospects -{" "}
                    <b
                    // style={{ color: "rgb(10, 104, 71)" }}
                    >
                      {item?.hot_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Semi Hot PT Prospects -{" "}
                    <b
                    // style={{ color: "#d9610b" }}
                    >
                      {item?.semi_hot_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Warm PT Prospects -{" "}
                    <b
                    // style={{ color: "#d78b03" }}
                    >
                      {item?.warm_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Cold PT Prospects -{" "}
                    <b
                    // style={{ color: "#157ef9" }}
                    >
                      {item?.cold_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Closed And Converted PT Prospects -{" "}
                    <b
                    // style={{ color: "#157ef9" }}
                    >
                      {item?.closed_cnvrtd_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Closed And Not Converted PT Prospects -{" "}
                    <b
                    // style={{ color: "#157ef9" }}
                    >
                      {item?.closed_not_cnvrtd_prspct || 0}
                    </b>
                  </span>
                  <span className="value semi-bold">
                    Not Specified PT Prospect -{" "}
                    <b
                    // style={{ color: "#157ef9" }}
                    >
                      {item?.not_specified_prspct || 0}
                    </b>
                  </span>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">Total Subscription</span>
                          <span className="value">{item?.total || 0}</span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">Total Handover</span>
                            <span className="value">
                              {item?.total_handover || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">Handover Pending</span>
                            <span className="value">
                              {item?.total_handover_pending || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">Handover Completed</span>
                            <span className="value">
                              {item?.total_handover_completed || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">Handover Completed</span>
                            <span className="value">
                              {item?.total_handover_completed || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">
                              PT Consultation Pending
                            </span>
                            <span className="value">
                              {item?.total_pending || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">
                              PT Consultation Completed
                            </span>
                            <span className="value">
                              {item?.total_completed || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">
                              PT Consultation Converted
                            </span>
                            <span className="value">
                              {item?.total_converted || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">
                              PT Consultation Done And Converted
                            </span>
                            <span className="value">
                              {item?.trial_done_cnvrtd || 0}
                            </span>
                          </div>
                          <div className="label-value">
                            <span className="label">
                              PT Consultation Not Done And Converted
                            </span>
                            <span className="value">
                              {item?.trial_done_cnvrtd || 0}
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default GymWiseStatsMobile;
